<template>
  <v-container>
    <h2 style="color:gray">Cài Đặt Lương Giáo Viên</h2>
    <v-divider class="my-3"></v-divider>
    <v-row class="py-3">
      <!-- kỳ lương -->
      <v-col cols="12" md="6">
        <v-checkbox
          hide-details
          value="salary-period-summary"
          :label="'Cho phép ' + roleName + ' tổng kết kỳ lương'"
          v-model="policies"
          class="ma-0 pa-0"
        ></v-checkbox>
      </v-col>
      <v-col cols="12" md="6">
        <v-checkbox
          hide-details
          value="salary-period-view-list"
          :label="'Cho phép ' + roleName + ' xem danh sách kỳ lương'"
          v-model="policies"
          class="ma-0 pa-0"
        ></v-checkbox>
      </v-col>
      <v-col cols="12" md="6">
        <v-checkbox
          hide-details
          value="salary-period-view-is-paid"
          :label="'Cho phép ' + roleName + ' xem danh sách giáo viên đã nhận/chưa nhận'"
          v-model="policies"
          class="ma-0 pa-0"
        ></v-checkbox>
      </v-col>
      <v-col cols="12" md="6">
        <v-checkbox
          hide-details
          value="salary-period-update-note"
          :label="'Cho phép ' + roleName + ' thêm ghi chú cho giáo viên'"
          v-model="policies"
          class="ma-0 pa-0"
        ></v-checkbox>
      </v-col>
      <!-- nhóm lương -->
      <v-col cols="12">
        <v-divider></v-divider>
      </v-col>
      <v-col cols="12" md="6">
        <v-checkbox
          hide-details
          value="salary-group-view-list"
          :label="'Cho phép ' + roleName + ' xem danh sách nhóm lương'"
          v-model="policies"
          class="ma-0 pa-0"
        ></v-checkbox>
      </v-col>
      <v-col cols="12" md="6">
        <v-checkbox
          hide-details
          value="salary-group-create"
          :label="'Cho phép ' + roleName + ' tạo mới nhóm lương'"
          v-model="policies"
          class="ma-0 pa-0"
        ></v-checkbox>
      </v-col>
      <v-col cols="12" md="6">
        <v-checkbox
          hide-details
          value="salary-group-update"
          :label="'Cho phép ' + roleName + ' cập nhật thông tin nhóm lương'"
          v-model="policies"
          class="ma-0 pa-0"
        ></v-checkbox>
      </v-col>
      <v-col cols="12" md="6">
        <v-checkbox
          hide-details
          value="salary-group-delete"
          :label="'Cho phép ' + roleName + ' xóa nhóm lương'"
          v-model="policies"
          class="ma-0 pa-0"
        ></v-checkbox>
      </v-col>
      <v-col cols="12" md="6">
        <v-checkbox
          hide-details
          value="salary-group-add-teacher"
          :label="'Cho phép ' + roleName + ' thêm giáo viên nhóm lương'"
          v-model="policies"
          class="ma-0 pa-0"
        ></v-checkbox>
      </v-col>
      <v-col cols="12" md="6">
        <v-checkbox
          hide-details
          value="salary-group-remove-teacher"
          :label="'Cho phép ' + roleName + ' xóa giáo viên nhóm lương'"
          v-model="policies"
          class="ma-0 pa-0"
        ></v-checkbox>
      </v-col>

      <!-- thành phần lương -->
      <v-col cols="12">
        <v-divider></v-divider>
      </v-col>
      <v-col cols="12" md="6">
        <v-checkbox
          hide-details
          value="salary-head-main-view-list"
          :label="'Cho phép ' + roleName + ' xem danh sách thành phần lương'"
          v-model="policies"
          class="ma-0 pa-0"
        ></v-checkbox>
      </v-col>
      <v-col cols="12" md="6">
        <v-checkbox
          hide-details
          value="salary-head-main-create"
          :label="'Cho phép ' + roleName + ' tạo mới thành phần lương'"
          v-model="policies"
          class="ma-0 pa-0"
        ></v-checkbox>
      </v-col>
      <v-col cols="12" md="6">
        <v-checkbox
          hide-details
          value="salary-head-main-delete"
          :label="'Cho phép ' + roleName + ' xóa thành phần lương'"
          v-model="policies"
          class="ma-0 pa-0"
        ></v-checkbox>
      </v-col>
      <v-col cols="12" md="6">
        <v-checkbox
          hide-details
          value="salary-head-main-update"
          :label="'Cho phép ' + roleName + ' cập nhật thông tin thành phần lương'"
          v-model="policies"
          class="ma-0 pa-0"
        ></v-checkbox>
      </v-col>
      <v-col cols="12" md="6">
        <v-checkbox
          hide-details
          value="salary-head-main-add-group-head"
          :label="'Cho phép ' + roleName + ' thêm áp dụng thành phần lương vào nhóm đối tượng'"
          v-model="policies"
          class="ma-0 pa-0"
        ></v-checkbox>
      </v-col>
      <v-col cols="12" md="6">
        <v-checkbox
          hide-details
          value="salary-head-main-delete-group-head"
          :label="'Cho phép ' + roleName + ' xóa áp dụng thành phần lương'"
          v-model="policies"
          class="ma-0 pa-0"
        ></v-checkbox>
      </v-col>
      <v-col cols="12" md="6">
        <v-checkbox
          hide-details
          value="salary-head-main-add-period-head"
          :label="'Cho phép ' + roleName + ' thêm kỳ lương trong áp dụng thành phần lương'"
          v-model="policies"
          class="ma-0 pa-0"
        ></v-checkbox>
      </v-col>
      <v-col cols="12" md="6">
        <v-checkbox
          hide-details
          value="salary-head-main-delete-period-head"
          :label="'Cho phép ' + roleName + ' xóa kỳ lương trong áp dụng thành phần lương'"
          v-model="policies"
          class="ma-0 pa-0"
        ></v-checkbox>
      </v-col>

      <!-- điều chỉnh lương -->
      <v-col cols="12">
        <v-divider></v-divider>
      </v-col>
      <v-col cols="12" md="6">
        <v-checkbox
          hide-details
          value="salary-head-adjust-view-list"
          :label="'Cho phép ' + roleName + ' xem danh sách điều chỉnh lương'"
          v-model="policies"
          class="ma-0 pa-0"
        ></v-checkbox>
      </v-col>
      <v-col cols="12" md="6">
        <v-checkbox
          hide-details
          value="salary-head-adjust-create"
          :label="'Cho phép ' + roleName + ' tạo mới điều chỉnh lương'"
          v-model="policies"
          class="ma-0 pa-0"
        ></v-checkbox>
      </v-col>
      <v-col cols="12" md="6">
        <v-checkbox
          hide-details
          value="salary-head-adjust-delete"
          :label="'Cho phép ' + roleName + ' xóa điều chỉnh lương'"
          v-model="policies"
          class="ma-0 pa-0"
        ></v-checkbox>
      </v-col>
      <v-col cols="12" md="6">
        <v-checkbox
          hide-details
          value="salary-head-adjust-update"
          :label="'Cho phép ' + roleName + ' cập nhật thông tin điều chỉnh lương'"
          v-model="policies"
          class="ma-0 pa-0"
        ></v-checkbox>
      </v-col>
      <v-col cols="12" md="6">
        <v-checkbox
          hide-details
          value="salary-head-adjust-add-group-head"
          :label="'Cho phép ' + roleName + ' thêm áp dụng điều chỉnh lương vào nhóm đối tượng'"
          v-model="policies"
          class="ma-0 pa-0"
        ></v-checkbox>
      </v-col>
      <v-col cols="12" md="6">
        <v-checkbox
          hide-details
          value="salary-head-adjust-delete-group-head"
          :label="'Cho phép ' + roleName + ' xóa áp dụng điều chỉnh lương'"
          v-model="policies"
          class="ma-0 pa-0"
        ></v-checkbox>
      </v-col>
      <v-col cols="12" md="6">
        <v-checkbox
          hide-details
          value="salary-head-adjust-add-period-head"
          :label="'Cho phép ' + roleName + ' thêm kỳ lương trong áp dụng điều chỉnh lương'"
          v-model="policies"
          class="ma-0 pa-0"
        ></v-checkbox>
      </v-col>
      <v-col cols="12" md="6">
        <v-checkbox
          hide-details
          value="salary-head-adjust-delete-period-head"
          :label="'Cho phép ' + roleName + ' xóa kỳ lương trong áp dụng điều chỉnh lương'"
          v-model="policies"
          class="ma-0 pa-0"
        ></v-checkbox>
      </v-col>
      <!-- truy thu -->
      <v-col cols="12">
        <v-divider></v-divider>
      </v-col>
      <v-col cols="12" md="6">
        <v-checkbox
          hide-details
          value="salary-head-sub-minus-view-list"
          :label="'Cho phép ' + roleName + ' xem danh sách khoản truy thu'"
          v-model="policies"
          class="ma-0 pa-0"
        ></v-checkbox>
      </v-col>
      <v-col cols="12" md="6">
        <v-checkbox
          hide-details
          value="salary-head-sub-minus-create"
          :label="'Cho phép ' + roleName + ' tạo mới khoản truy thu'"
          v-model="policies"
          class="ma-0 pa-0"
        ></v-checkbox>
      </v-col>
      <v-col cols="12" md="6">
        <v-checkbox
          hide-details
          value="salary-head-sub-minus-delete"
          :label="'Cho phép ' + roleName + ' xóa khoản truy thu'"
          v-model="policies"
          class="ma-0 pa-0"
        ></v-checkbox>
      </v-col>
      <v-col cols="12" md="6">
        <v-checkbox
          hide-details
          value="salary-head-sub-minus-update"
          :label="'Cho phép ' + roleName + ' cập nhật thông tin khoản truy thu'"
          v-model="policies"
          class="ma-0 pa-0"
        ></v-checkbox>
      </v-col>
      <v-col cols="12" md="6">
        <v-checkbox
          hide-details
          value="salary-head-sub-minus-add-group-head"
          :label="'Cho phép ' + roleName + ' thêm áp dụng khoản truy thu vào nhóm đối tượng'"
          v-model="policies"
          class="ma-0 pa-0"
        ></v-checkbox>
      </v-col>
      <v-col cols="12" md="6">
        <v-checkbox
          hide-details
          value="salary-head-sub-minus-delete-group-head"
          :label="'Cho phép ' + roleName + ' xóa áp dụng khoản truy thu'"
          v-model="policies"
          class="ma-0 pa-0"
        ></v-checkbox>
      </v-col>
      <v-col cols="12" md="6">
        <v-checkbox
          hide-details
          value="salary-head-sub-minus-add-period-head"
          :label="'Cho phép ' + roleName + ' thêm kỳ lương trong áp dụng khoản truy thu'"
          v-model="policies"
          class="ma-0 pa-0"
        ></v-checkbox>
      </v-col>
      <v-col cols="12" md="6">
        <v-checkbox
          hide-details
          value="salary-head-sub-minus-delete-period-head"
          :label="'Cho phép ' + roleName + ' xóa kỳ lương trong áp dụng khoản truy thu'"
          v-model="policies"
          class="ma-0 pa-0"
        ></v-checkbox>
      </v-col>

      <!-- hoàn trả -->
      <v-col cols="12">
        <v-divider></v-divider>
      </v-col>
      <v-col cols="12" md="6">
        <v-checkbox
          hide-details
          value="salary-head-sub-sum-view-list"
          :label="'Cho phép ' + roleName + ' xem danh sách khoản hoàn trả'"
          v-model="policies"
          class="ma-0 pa-0"
        ></v-checkbox>
      </v-col>
      <v-col cols="12" md="6">
        <v-checkbox
          hide-details
          value="salary-head-sub-sum-create"
          :label="'Cho phép ' + roleName + ' tạo mới khoản hoàn trả'"
          v-model="policies"
          class="ma-0 pa-0"
        ></v-checkbox>
      </v-col>
      <v-col cols="12" md="6">
        <v-checkbox
          hide-details
          value="salary-head-sub-sum-delete"
          :label="'Cho phép ' + roleName + ' xóa khoản hoàn trả'"
          v-model="policies"
          class="ma-0 pa-0"
        ></v-checkbox>
      </v-col>
      <v-col cols="12" md="6">
        <v-checkbox
          hide-details
          value="salary-head-sub-sum-update"
          :label="'Cho phép ' + roleName + ' cập nhật thông tin khoản hoàn trả'"
          v-model="policies"
          class="ma-0 pa-0"
        ></v-checkbox>
      </v-col>
      <v-col cols="12" md="6">
        <v-checkbox
          hide-details
          value="salary-head-sub-sum-add-group-head"
          :label="'Cho phép ' + roleName + ' thêm áp dụng khoản hoàn trả vào nhóm đối tượng'"
          v-model="policies"
          class="ma-0 pa-0"
        ></v-checkbox>
      </v-col>
      <v-col cols="12" md="6">
        <v-checkbox
          hide-details
          value="salary-head-sub-sum-delete-group-head"
          :label="'Cho phép ' + roleName + ' xóa áp dụng khoản hoàn trả'"
          v-model="policies"
          class="ma-0 pa-0"
        ></v-checkbox>
      </v-col>
      <v-col cols="12" md="6">
        <v-checkbox
          hide-details
          value="salary-head-sub-sum-add-period-head"
          :label="'Cho phép ' + roleName + ' thêm kỳ lương trong áp dụng khoản hoàn trả'"
          v-model="policies"
          class="ma-0 pa-0"
        ></v-checkbox>
      </v-col>
      <v-col cols="12" md="6">
        <v-checkbox
          hide-details
          value="salary-head-sub-sum-delete-period-head"
          :label="'Cho phép ' + roleName + ' xóa kỳ lương trong áp dụng khoản hoàn trả'"
          v-model="policies"
          class="ma-0 pa-0"
        ></v-checkbox>
      </v-col>
    </v-row>
    <v-divider class="my-3"></v-divider>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn color="primary" text class="mx-5" @click="reset()">Đặt lại</v-btn>
      <v-btn color="primary" @click="save()">Lưu</v-btn>
    </v-card-actions>
  </v-container>
</template>

<script>
import mixins from './helper/mixins'
export default {
  mixins: [mixins]
}
</script>
